import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function EnrichmentUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-4561">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4562">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4563">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4564">
            Local business data enrichment for{' '}
            <span className="text-blue-600" data-id="element-4565">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4566">
            From sales to marketing, see how teams use local business contact
            enrichment to grow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4567">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4568">
            <div data-id="element-4569">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4570">
                CRM enrichment
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4571">
                Enrich your Salesforce or HubSpot with verified local business
                contacts, owner emails, and business profiles.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4572">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4573" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4574">
                We enriched 50,000 local business records in our CRM over a
                single weekend.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4575">
                — Rachel K., RevOps lead
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4576">
            <div data-id="element-4577">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4578">
                Sales prospecting
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4579">
                Turn basic local business lists into outreach-ready prospect
                data with verified emails and direct phones.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4580">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4581" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4582">
                Local business contact enrichment doubled our SDR team's connect
                rate.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4583">
                — James T., Sales director
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4584">
            <div data-id="element-4585">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4586">
                Market research
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4587">
                Enrich local business data with tech stacks, revenue, and
                employee counts to identify high-value segments.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4588">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4589" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4590">
                Business profile enrichment helped us find 3 underserved markets
                in our first month.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4591">
                — Lisa P., Strategy manager
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}